

















































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { studentModule } from '@/store/modules/entities/student.module';
import { Student } from '@/models/student/student';
import { StudentCompetencyGrowth } from '@/models/student/student-competency-growth';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import { CompetencyGrowthEchartService } from '@/service/echart/competency-growth.echart.service';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GLoading from '@/components/GLoading.vue';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GStudentAllCompetencyGrowthChart',
  components: { GLoading, GCustomBreadCrumb, GCompetencyLabel },
  computed: {},
  methods: {},
})
export default class GStudentAllCompetencyGrowthChart extends Mixins(GPageBase) {
  studentID: number = 0;
  competencyGrowthCharts: CompetencyGrowthEchartService[] = [];
  readonly CHART_HEIGHT = 240;

  created() {
    this.studentID = parseInt(this.$route.params.studentID);
  }
  async mounted() {
    this.competencyGrowthCharts = this.studentCompetencyGrowth.map((studentCompetencyGrowth: StudentCompetencyGrowth) => new CompetencyGrowthEchartService(studentCompetencyGrowth));
    this.competencyGrowthCharts = this.competencyGrowthCharts.map((service: CompetencyGrowthEchartService) => {
      service.isFunchart = false;
      return service;
    });
  }

  get student(): Student {
    return studentModule.student;
  }

  get competencyIDs(): number[] {
    return Constants.CompetencyIDsBySortedType;
  }

  get studentCompetencyGrowth(): StudentCompetencyGrowth[] {
    return studentAllCompetencyModule.studentCompetencyGrowth;
  }
}
